export default __webpack_public_path__ + "static/media/alive.f337a224.svg";